module.exports = __webpack_public_path__ + "static/tech-matters-more-than-you-think-b9e5e86d987332c15c6591f18b9be2d3.png";